export var CollapsibleListData_InitialExpandedItems;
(function (CollapsibleListData_InitialExpandedItems) {
    /** FIRST - First item will be expended initally */
    CollapsibleListData_InitialExpandedItems["FIRST"] = "FIRST";
    /** ALL - All items will expended initally */
    CollapsibleListData_InitialExpandedItems["ALL"] = "ALL";
    /** NONE - All items collapsed initally */
    CollapsibleListData_InitialExpandedItems["NONE"] = "NONE";
    CollapsibleListData_InitialExpandedItems["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CollapsibleListData_InitialExpandedItems || (CollapsibleListData_InitialExpandedItems = {}));
export var CollapsibleListData_Direction;
(function (CollapsibleListData_Direction) {
    /** LTR - Left-to-right */
    CollapsibleListData_Direction["LTR"] = "LTR";
    /** RTL - Right-to-left */
    CollapsibleListData_Direction["RTL"] = "RTL";
    CollapsibleListData_Direction["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CollapsibleListData_Direction || (CollapsibleListData_Direction = {}));
//# sourceMappingURL=plugin_collapsible_list.enums.js.map